import { AuthService } from 'services';
import {
  getSavedSubscription,
  getSubscription,
  pushSubscriptionNotification,
  pushSubscriptionUserId,
  startPollingForPushSubscriptionChange,
} from 'services/pushNotificationsService';

import { ACTION_TYPES } from './index';

export const __updateuser = (user, skipSusbscriptionStep) => async (dispatch, getState) => {
  if ('Notification' in window && Notification.permission === 'granted' && !skipSusbscriptionStep) {
    const existingUser = getState().user;
    // Check saved subscription only when the notification permission is granted
    const savedSubscription = getSavedSubscription();
    /**
     * @type {PushSubscription}
     */
    let newSubscription;
    // Fetch the new subscription from push manager
    try {
      newSubscription = await getSubscription();
    } catch (err) {
      console.error(err);
    }
    if (newSubscription) {
      newSubscription = newSubscription.toJSON();

      const savedUserId = localStorage.getItem(pushSubscriptionUserId);

      // Unsubscribe from the old subscription
      if (savedSubscription && (savedUserId || existingUser?.userId))
        pushSubscriptionNotification(
            savedUserId ?? existingUser?.userId,
            'unsubscribe',
            savedSubscription,
            false,
            true
        );

      if (newSubscription) {
        // Subscribe with the new subscription
        pushSubscriptionNotification(user?.userId, 'subscribe', newSubscription, false, true)
            .then(() => {
              if (user.userId) {
                startPollingForPushSubscriptionChange(user)
              }
            })
      }
    }
  }
  return dispatch({
    type: ACTION_TYPES.UPDATE_USER_FULL,
    payload: user,
  });
};

export const updateAnonymousUser = (user) => ({
  type: ACTION_TYPES.UPDATE_ANONYMOUS_USER,
  payload: user,
});

/**
 *
 * @param {boolean} skipSusbscriptionStep
 * @returns {Promise<any>}
 */
export const updateUser =
  (skipSusbscriptionStep = false) =>
  async (dispatch) => {
    return AuthService.getUserProfile()
      .then((response) => {
        dispatch(__updateuser(response, skipSusbscriptionStep));
      })
      .catch((error) => {
        console.error('error :', error);
      });
  };
